import React, { Component } from 'react'
import { connect } from 'react-redux'
import { AppSettings , Storage} from '../../configs'
import queryString from 'query-string'
import { MsalContext } from '@azure/msal-react';
import {
    getControlConfigAction,
    getEmployeeInfoAction
} from '../../redux/actions/MasterAction'
import {
    startLoginAction,
    loginAction,
    getADUserInfoAction,
    getDefaultBusinessPlaceAction,
    getUserInformationAction
}
    from '../../redux/actions/UserAction'

import { MsgBoxContainer, msg } from '../../components/Notifications/MsgBox'
import {
    Loading,
    BreadCrumb
}
    from '../../components'

import '../../assets/css/tor-template-list.css'
import moment from 'moment'
import { startLoadingAction, stopLoadingAction } from "../../redux/actions/AppAction.js"
import {loginRequest} from '../../configs/authConfig';
import UserServices from '../../services/UserServices.js'
import Divider from '@material-ui/core/Divider'
import Box from '@material-ui/core/Box'


class LoginScreen extends Component {
    constructor(props) {
        super(props)

        this.state = {
            error: '',
            username: '',
            password: '',
            userAD:null,
            mode: ''
        }

        this.handleInputChange = this.handleInputChange.bind(this)
        this.handleKeyUp=this.handleKeyUp.bind(this)
        this.handleLogin = this.handleLogin.bind(this)
        this.onLoggedIn = this.onLoggedIn.bind(this)

    }
    static contextType = MsalContext;

    handleInputChange(event) {
        const target = event.target
        const value = target.type === 'checkbox' ? target.checked : target.value
        const name = target.name

        this.setState({
            [name]: value
        })
    }

    handleKeyUp(event){
        if(event.keyCode===13){
            event.preventDefault()

            this.handleLogin(event)
        }
    }

    async handleLogin(event) {
        //this.props.startLoading()
        let { username, password, userAD, mode } = this.state

        //ถ้าไม่มีข้อมูล AD
        if (!userAD || mode=="logout") {
            if (!username) {
                msg.error("กรุณาระบุ Username!")
                return
            }
        }

        this.props.startlogin()

        let loginResult = null

        if (userAD 
            && userAD.emp_code
            && mode !== "logout") 
        {
            this.props.login(userAD.emp_code, "#AD#" + btoa(userAD.emp_code)).then((response) => {
                loginResult = response.data
                this.onLoggedIn(loginResult.success, loginResult.errorMessage)
            }).catch(error => {
                if (error.message.indexOf("timeout") > -1) {
                    msg.error("เชื่อมต่อ Server เกินกว่าเวลาที่กำหนด กรุณาตรวจสอบการเชื่อมต่อ")
                }
                else {
                    msg.error(error)
                }
            })
        } else {
            this.props.login(username, password).then((response) => {
                loginResult = response.data
                this.onLoggedIn(loginResult.success, loginResult.errorMessage)
            }).catch(error => {
                console.log(error)
                if (error.message.indexOf("timeout") > -1) {
                    msg.error("เชื่อมต่อ Server เกินกว่าเวลาที่กำหนด กรุณาตรวจสอบการเชื่อมต่อ")
                }
                else {
                    msg.error(error)
                }
            })
        }

        //this.props.stopLoading()
    }

    async onLoggedIn(success, errorMessage) {
        if (success === true && Storage.getUser() && Storage.getRole()) {
            
            const role = Storage.getRole()
            const user = Storage.getUser()
            const userPIS = Storage.getEmployeePIS()

            let unitCode = null

            if (userPIS) {
                unitCode = userPIS.departmentCode
            } else {
                unitCode = user.unitCode
            }
            this.props.stopLoading()
            this.props.getDefaultBusinessPlace(unitCode)
            
            this.props.getControlConfig(role, null).then(() => {

                
                this.props.history.push(AppSettings.defaultUrl)
            })
        } else {
            this.props.stopLoading()
            if (errorMessage) {
                msg.error(errorMessage)
            } else {
                msg.error("ไม่สามารถเข้าสู่ระบบได้!")
            }
        }
    }

    

    async componentDidMount() {
        // console.log("LoginScreen.componentDidMount()")

         let { location } = this.props
         const qs = queryString.parse(location.params)
         
         let userAD = null

        const userLoggedIn = Storage.getUser()
        if (userLoggedIn && userLoggedIn.token) {
            //ถ้าเคย Log in ผ่านไปแล้ว check date ภายในวัน ถ้าใช่ไม่ต้อง login ใหม่
            const datelocalStorage = Storage.getDatelocalStorage()
            let getdate = moment(new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 0, 0)).format('YYYYMMDD')
            if (datelocalStorage == getdate) {
                this.onLoggedIn(true, null)
                return
            }
            else {
                //ถ้าเคย Log in ผ่านไปแล้ว จะไปดึงข้อมูล user มาอัพเดตใน loclstorage
                this.props.startlogin()
                try {
                    await this.props.getUserInformation(userLoggedIn)
                } catch (error) {
                    console.log("getUserInformation error:")
                    console.log(error)
                }

                this.onLoggedIn(true, null)
                return
            }
        }
 
         await this.props.getADUserInfo().then(response=>{
             console.log("getADUserInfo success:")
             
             userAD=response.data
         }).catch(error=>{
             console.log("getADUserInfo error:")
             console.log(error)
         })
 
         await this.setState({userAD:userAD})
         
 
         if (qs) {
 
             let { mode } = qs
 
             await this.setState({mode:mode})
 
             if (mode !== "logout") {
                 if (userAD != null) {
                     //Auto login กรณีมีสิทธิ์ AD ในเครื่องอยู่แล้ว
                     this.handleLogin(null)
                 }
             }
         }
     }

    render() {
        const { isLoading } = this.props

        const isAuthenticated = this.context.accounts.length > 0;
        const msalInstance = this.context.instance;
        const vShowLogin = Storage.getShowLogin();
        const isShowLogin = vShowLogin === "1" || vShowLogin === 1;


        if(isAuthenticated)
        {

            
            msalInstance.acquireTokenSilent({
                scopes: ["User.Read"],
                account: this.context.accounts[0]
            }).then((response) => {
                if(response) {
                    UserServices.loginFromADToken(response.tokenType, response.accessToken).then(responseApiRRS=>{

                        if(responseApiRRS?.success === true)
                        {
                            Storage.setUser(responseApiRRS.user)
                            Storage.setRole(responseApiRRS.employee ? responseApiRRS.employee.role : "C")
                            Storage.setEmployeePIS(responseApiRRS.employee)
                            Storage.setAppReadonly(responseApiRRS.readonly)

                            this.onLoggedIn(true, null)

                            window.location.href = "/#/mytask"
                        }
                    })
                }
            });
        }
        

        return (
            <div className="tor tor-template-list">
                <div id="main-content">
                    <div className="page-body">
                    <BreadCrumb breadcrumb={[]}></BreadCrumb>
                        {/* <div className="breadcrumb-container sp-breadcrumb-container">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb sp-breadcrumb">
                                    <li className="breadcrumb-item sp-breadcrumb-item active" aria-current="page">Home</li>
                                </ol>
                            </nav>
                        </div> */}

                        <div className="sp-page-header-panel row">
                            <div className="col-md-5 sp-page-header">
                                <h1 className="sp-page-header1">Login</h1>
                            </div>
                        </div>

                        <div className="sp-page-result-container">
                            <div>
                                <div style={{width:10,height:66}}></div>
                                <div className="row justify-content-center" >
                                    <div className="logo-img"><img src="/assets/images/ptt-logo.svg" alt="PTT" style={{width:160,marginBottom:30}} /></div>
                                </div>
                                { isShowLogin && <div className="sp-tor-content-container">
                                    <div className="sp-page-wrapper">
                                        {
                                            this.state.error && (
                                                <div className="row justify-content-center">
                                                    <div className="col-12 col-lg-3">
                                                        <p style={{
                                                            textAlign: 'center',
                                                            color: '#FF0000',
                                                            fontWeight: 'bold'
                                                        }}>
                                                            {this.state.error}
                                                        </p>
                                                    </div>
                                                </div>
                                            )
                                        }
                                        <div className="row justify-content-center">
                                            <div className="col-12 col-lg-3">
                                                <label htmlFor="username">Username</label>
                                                <div className="form-group">
                                                    <input
                                                        type="text"
                                                        id="username"
                                                        name="username"
                                                        className="form-control"
                                                        // vv="ptt\รหัสพนักงาน"
                                                        placeholder="รหัสพนักงาน"
                                                        value={this.state.username}
                                                        onChange={this.handleInputChange}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row justify-content-center">
                                            <div className="col-12 col-lg-3">
                                                <label htmlFor="password">Password</label>
                                                <div className="form-group">
                                                    <input
                                                        type="password"
                                                        id="password"
                                                        name="password"
                                                        className="form-control"
                                                        placeholder="รหัสผ่าน ตัวเดียวกับที่ใช้เข้าเครื่อง"
                                                        value={this.state.password}
                                                        onChange={this.handleInputChange}
                                                        onKeyUp={this.handleKeyUp}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>}
                                { isShowLogin && <div className="row justify-content-center">
                                    <div className="col-12 col-lg-3">
                                        <button id="btnLogin" type="button" onClick={this.handleLogin} className="btn btn-apply btn-block">
                                            Login
                                            </button>
                                    </div>
                                </div>}
                                <div className="row justify-content-center padding-1">
                                <div className="col-12 col-lg-3">
                                    <Box p={2}>
                                    <Divider></Divider>
                                    </Box>
                                
                                    </div>
                                    
                                </div>
                                {!isAuthenticated && <div >
                                <button id="btnLogin" type="button" onClick={() => msalInstance.loginRedirect(loginRequest)} className="btn btn-apply btn-block">
                                            PTT USER
                                            </button>
                                </div>}
                                <div className="row justify-content-center">
                                <div className="rrs-form" style={{visibility:"hidden"}}>
                                    <div className="rrs-detail-data" >
                                        <label className="rrs-label" style={{fontWeight:"bold",textDecoration:"underline"}}>หมายเหตุ</label>
                                    </div>
                                    <div className="rrs-detail-data">
                                        <label className="rrs-label">การ Login เข้าระบบให้ใช้ format ดังนี้</label>
                                    </div>
                                    <div className="rrs-detail-data">
                                        <label className="rrs-label"><span style={{fontWeight:"bold"}}>Username</span> : ptt\รหัสพนักงาน</label>
                                    </div>
                                    <div className="rrs-detail-data">
                                        <label className="rrs-label"><span style={{fontWeight:"bold"}}>Password</span> &nbsp;: ระบุตามรหัสผ่านเดียวกับที่ใช้เข้าเครื่อง</label>
                                    </div>
                                </div>
                            </div>
                            </div>
                            <div className="text-right">
                                version {AppSettings.appVersion}
                            </div>
                        </div>
                    </div>
                </div>
                <MsgBoxContainer />
                <Loading isLoading={isLoading} />
            </div>
        )
    }
}

const mapStateToProps = state => {
    const { AppRedux } = state
    return {
        isLoading: AppRedux.isLoading
    }
}

const mapDispatchToProps = dispatch => {
    return {
        startlogin: () => dispatch(startLoginAction()),
        login: (username, password) => dispatch(loginAction(username, password)),
        getADUserInfo: () => getADUserInfoAction(),
        getEmployeeInfo: (employeeCode) => dispatch(getEmployeeInfoAction(employeeCode)),
        getDefaultBusinessPlace : (unit_code) => dispatch(getDefaultBusinessPlaceAction(unit_code)),
        getControlConfig: (role, documentType) => dispatch(getControlConfigAction(role, documentType, 1, 0)),
        startLoading: () => dispatch(startLoadingAction()),
        stopLoading: () => dispatch(stopLoadingAction()),
        getUserInformation: (user) => dispatch(getUserInformationAction(user)),
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(LoginScreen);